import React from 'react';
import cn from 'classnames';
import { Tooltip } from 'swag-client-common/components/info/tooltip';
import { Placement } from 'swag-client-common/constants';
import InfoIcon from 'swag-client-common/components/icons/info-icon';
import { Price } from 'swag-client-common/utils/price';
import classes from './setupfee-tooltip.scss';
const defaultTooltipText = 'In the future, if you reorder this product, your full setup fee for the item will be free.';
const setupFeeTooltipStyles = {
  popper: classes.setupFeeTooltipPopper,
  tooltip: classes.tooltipRoot
};
function getTooltipText({
  isSharedOrRelatedItem,
  totalSharedSetupFee
}) {
  if (isSharedOrRelatedItem && totalSharedSetupFee) {
    return `
      This is a Shared Setup Fee for this item across your order. 
      The total setup fee is ${Price.formatPrice(totalSharedSetupFee)}, and the portion related to this part of your order is shown here. 
      ${defaultTooltipText}`;
  }
  return defaultTooltipText;
}
export const SetupFeeTooltip = ({
  isSharedOrRelatedItem = false,
  infoWrapperClassName = '',
  infoButtonClassName = '',
  placement,
  isLimitedEdition,
  totalSharedSetupFee
}) => {
  return /*#__PURE__*/React.createElement(Tooltip, {
    title: getTooltipText({
      isSharedOrRelatedItem,
      totalSharedSetupFee
    }),
    placement: placement || Placement.RIGHT,
    mode: "light",
    className: infoWrapperClassName,
    classes: setupFeeTooltipStyles
  }, /*#__PURE__*/React.createElement(InfoIcon, {
    className: cn(classes.infoButton, infoButtonClassName),
    isLimitedEdition: isLimitedEdition
  }));
};